'use strict';

const Backbone = require('backbone');

const PageIndex = require('pages/PageIndex/PageIndex');
const PagePlatform = require('pages/PagePlatform/PagePlatform');

const PageNames = {
    index: 'index',
    platform: 'platform'
};

module.exports = Backbone.Router.extend({
    routes: function () {
        return this._getGlobalRoutes();
    },

    _getGlobalRoutes: function () {
        return {
            '': 'index',
            'index.html': 'index',

            'platform(/)': 'platform',
            'platform/overview(/)': 'platform',
            'platform.html': 'platform'
        };
    },

    initialize: function () {

    },

    index: function () {
        this.initPage(PageIndex, PageNames.index);
    },

    platform: function () {
        this.initPage(PagePlatform, PageNames.platform);
    },

    initPage: function (Page, name, popup) {
        if (!this.pages) {
            this.pages = {};
        }

        if (this.pages[name]) {
            return;
        }

        this.pages[name] = new Page({
            router: this,
            popup: popup
        });
    },

    start: function () {
        const root = '/';
        Backbone.history.start({
            pushState: true,
            root: (window.app.settings.lang ? '/intl/' + window.app.settings.lang : '') +
                root + '/',
            silent: false
        });
    }
});
